import React from 'react';
import SvgOK from '@icons/check-square.svg?react';
import SvgERROR from '@icons/alert-circle.svg?react';
import SvgWARNING from '@icons/alert.svg?react';
import { AiChatClassificationOutDTO, IntentEnum } from '@api/ringil-api.v2.tsx';
import { AiAlertButton } from '@components/ai/AiAlertButton.tsx';

export const intentEnumIcons: Record<IntentEnum, React.FC<React.SVGProps<SVGSVGElement>>> = {
  ISSUE: SvgERROR,
  QUESTION_OR_REQUEST: SvgWARNING,
  CONFIRMATION: SvgOK,
  UNKNOWN: null,
};

export type AiButtonProps = {
  aiChatClassification: AiChatClassificationOutDTO;
};

export function getIntentIconColorClass(intent: IntentEnum) {
  switch (intent) {
    case IntentEnum.ISSUE:
      return 'text-complementary-error';
    case IntentEnum.QUESTION_OR_REQUEST:
      return 'text-complementary-warning';
    case IntentEnum.CONFIRMATION:
      return 'text-complementary-success';
    case IntentEnum.UNKNOWN:
    default:
      return 'text-content-gr2';
  }
}

export const AiChatClassificationButton: React.FC<AiButtonProps> = ({
                                                                      aiChatClassification,
                                                                    }) => {

  function getIntentClassName(intent: IntentEnum) {
    switch (intent) {
      case IntentEnum.ISSUE:
        return 'border-complementary-error bg-complementary-errorLight shadow-[0_0_4px_0_rgba(228,0,43,0.4)]';
      case IntentEnum.QUESTION_OR_REQUEST:
        return 'border-complementary-warning bg-complementary-warningLight shadow-[0_0_4px_0_rgba(255, 209, 0, 0.4)]';
      case IntentEnum.CONFIRMATION:
        return 'border-complementary-success bg-complementary-successLight shadow-[0_0_4px_0_rgba(0,198,94,0.4)]';
      case IntentEnum.UNKNOWN:
      default:
        return 'border-content-gr2 bg-content-quaternary shadow-[0_0_4px_0_rgba(0,0,0,0.1)]';
    }
  }

  return (
    <AiAlertButton
      title={
        <div className={`flex flex-row gap-1 items-center justify-center`}>
          <span>
            {intentEnumIcons[aiChatClassification.intent] &&
              React.createElement(
                intentEnumIcons[aiChatClassification.intent],
                {
                  width: 16,
                  height: 16,
                  className: getIntentIconColorClass(aiChatClassification.intent),
                }
              )
            }
          </span>
          <span className="text-content-primary font-dm-sans text-[14px] font-medium leading-[12px] not-italic">
            1x
          </span>
        </div>
      }
      className={getIntentClassName(aiChatClassification.intent)}
    />
  );
};